export default "### Datenschutzerklärung\n\n[Hier können Sie die Datenschutzerklärung für die Software einfügen...]"